import axios from 'axios'

// Create axios instance with default config
export const apiClient = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.exp ? payload.exp * 1000 < Date.now() : false
  } catch { return false }
}

let loggingOut = false
function dispatchLogout() {
  if (loggingOut) return
  loggingOut = true
  localStorage.removeItem('stonks_token')
  window.dispatchEvent(new Event('auth:logout'))
  setTimeout(() => { loggingOut = false }, 3000)
}

// Inject JWT token — reject immediately if already expired rather than waiting for a 401
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('stonks_token')
    if (token) {
      if (isTokenExpired(token)) {
        dispatchLogout()
        return Promise.reject(new axios.Cancel('Token expired'))
      }
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor — only logout when the app token itself is missing/expired.
// A 401 from a sub-service endpoint (e.g. Discogs not connected) should not log the user out.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const token = localStorage.getItem('stonks_token')
      if (!token || isTokenExpired(token)) {
        dispatchLogout()
      }
    } else if (error.response) {
      const message = error.response.data?.error || error.message
      console.error('API Error:', message)
    } else if (error.request) {
      console.error('Network Error:', error.message)
    }
    return Promise.reject(error)
  }
)

export default apiClient
